import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IRiskManagement } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-risk-management',
  templateUrl: './risk-management.component.html',
  styleUrls: ['./risk-management.component.scss'],
})
export class RiskManagementComponent implements OnInit {
  public riskManagement!: IRiskManagement[];

  loading: boolean = false;
  public headerList: Array<any> = [
    {
      label: 'Risk',
      colDef: { fieldName: 'risk' },
    },
    {
      label: 'Engagement',
      colDef: { fieldName: 'engagement' },
    },
    {
      label: 'Severity',
      colDef: { fieldName: 'severity' },
    },
    {
      label: 'Owner',
      colDef: { fieldName: 'owner' },
    },
    {
      label: 'Mitigation Plan',
      colDef: { fieldName: 'mitigationPlan' },
    },
  ];
  

  constructor(
    private userService: UserService,
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  getUserImage(obj: IRiskManagement, email: string) {
    this.userService.getProfilePic({ emailId: email }).subscribe((res: any) => {
      if (!!res) {
        obj.baseImg = res.base64ProfileImage;
      }
    });
  }

  ngOnInit(): void {
    this.loading = true;
    // const id = this.route.snapshot.paramMap.get('id');
    this.homeServiceRef.getEngagementId().subscribe(enagementId => {
      const id = enagementId;
      if (id)
        this.homeServiceRef.getRiskManagement(id).subscribe((res) => {
          res.forEach((obj: IRiskManagement) => {
            this.getUserImage(obj, obj.ownerEmail);
          });
          this.riskManagement = res;
          this.loading = false;
        });
    });
  }
}
